import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { selectMuted, setMute } from '~/redux/slices/sound-control'

interface PortalMuteButtonProps {
  className?: string
  muteElement: React.ReactNode
  unmuteElement: React.ReactNode
}

const PortalMuteButton: React.FC<PortalMuteButtonProps> = ({ className = '', muteElement, unmuteElement }) => {
  const globallyMuted = useAppSelector(selectMuted)
  const dispatch = useAppDispatch()

  return (
    <div
      className={`cursor-pointer transform active:scale-80 transition duration-300 ${className}`}
      onClick={() => dispatch(setMute(!globallyMuted))}
    >
      {globallyMuted ? unmuteElement : muteElement}
    </div>
  )
}

export default PortalMuteButton
